import { settings } from "shared";
import assetManifest from "./assetManifest";

export function getImageUrl(src: string): string {
  // Ensure src starts with /
  const imageSrc = src.startsWith("/") ? src : `/${src}`;
  const staticDomain = settings.assetDomain;
  const url = `${staticDomain}${imageSrc}`;
  const hash = assetManifest[imageSrc];
  if (settings.hashFiles && hash) {
    const urlComponents = url.split("/");
    const fileName = urlComponents.pop();
    urlComponents.push(fileName.replace(/\.\w+$/, `.${hash}$&`));
    return urlComponents.join("/");
  }
  return url;
}

const favicons = {
  default: getImageUrl("/favicons/favicon.ico"),
  16: getImageUrl("/favicons/favicon-16x16.png"),
  32: getImageUrl("/favicons/favicon-32x32.png"),
  appleTouch: getImageUrl("/favicons/apple-touch-icon.png"),
  fort: {
    default: getImageUrl("/favicons/fort/favicon.ico"),
    16: getImageUrl("/favicons/fort/favicon-16x16.png"),
    32: getImageUrl("/favicons/fort/favicon-32x32.png"),
    appleTouch: getImageUrl("/favicons/fort/apple-touch-icon.png"),
  },
};

const Home = {
  defineBrand: "https://cdn.lingoapp.com/UXTHx69/home_buildYourBrand.png?format=auto",
  empowerTeams: "https://cdn.lingoapp.com/wPM233n/home_empowerTeams.png?format=auto",
  upToDate: "https://cdn.lingoapp.com/y1868SN/home_upToDate.png?format=auto",
  hero: "https://cdn.lingoapp.com/0XNkmPg/Hero.png?width=1200&format=auto",
  showcase: "https://cdn.lingoapp.com/a2Z490X/showcase_3-2.png?format=auto",
};

const Product = {
  Kits: {
    hero: "https://cdn.lingoapp.com/yjyy87M/product-kits-hero_21-9.png?format=auto",
    contentContext:
      "https://cdn.lingoapp.com/YAob40C/product-kits-contentContext_3-2.png?format=auto",
    customKits: "https://cdn.lingoapp.com/hW2rKMF/product-kits-customKits_3-2.png?format=auto",
  },
  Library: {
    hero: "https://cdn.lingoapp.com/FrSkF94/product-library-hero_21-9.png?format=auto",
    assetManagement:
      "https://cdn.lingoapp.com/sQDNbzZ/product-library-assetManagement_3-2.png?format=auto",
    dam: "https://cdn.lingoapp.com/lOaBjWV/product-library-dam_3-2.png?format=auto",
  },
  Insights: {
    hero: "https://cdn.lingoapp.com/udlYGQz/product-insights-hero_21-9.png?format=auto",
    optimize: "https://cdn.lingoapp.com/Tav7rQW/product-insights-optimize_3-2.png?format=auto",
    content: "https://cdn.lingoapp.com/JPCn3wU/product-insights-content_3-2.png?format=auto",
  },
  CustomBranding: {
    hero: "https://cdn.lingoapp.com/9bQZn5q/product-customBranding-hero_21-9.png?format=auto",
    customize:
      "https://cdn.lingoapp.com/n0mknDh/product-customBranding-customize_3-2.png?format=auto",
    showcase:
      "https://cdn.lingoapp.com/DGA5aAd/product-customBranding-showcase_3-2.png?format=auto",
  },
};

const Integrations = {
  hero: "https://cdn.lingoapp.com/QtU1hRh/integrations-hero_21-9.png?format=auto",
  web: "https://cdn.lingoapp.com/Y9wrTCa/integrations-web_3-2.png?format=auto",
  Figma: {
    hero: "https://cdn.lingoapp.com/jxkGYr9/integrations-figma_3-2.png?format=auto",
    card: "https://cdn.lingoapp.com/R13fd9g/Integrations - Figma - Card.png?format=auto",
    content: "https://cdn.lingoapp.com/rCQLsmN/integrations-figma-content_3-2.png?format=auto",
  },
  Dropbox: {
    hero: "https://cdn.lingoapp.com/Cu1ApMP/Integrations - Dropbox - Hero.png?format=auto",
    card: "https://cdn.lingoapp.com/zvHE8k5/Integrations - Dropbox - Card.png?format=auto",
    content: "https://cdn.lingoapp.com/kk2LAPE/integrations-dropbox-content_3-2.png?format=auto",
  },
  Google: {
    hero: "https://cdn.lingoapp.com/PKpQhQM/Integrations - Google Drive - Hero.png?format=auto",
    card: "https://cdn.lingoapp.com/wVpn69h/Integrations - Google Drive - Card.png?format=auto",
    content: "https://cdn.lingoapp.com/rUmeIVK/integrations-google-content_3-2.png?format=auto",
  },
  Api: {
    hero: "https://cdn.lingoapp.com/7dA6rBc/integrations-api_3-2.png?format=auto",
    card: "https://cdn.lingoapp.com/lsc6leV/Integrations API - Card.png?format=auto",
    content: "https://cdn.lingoapp.com/4a9EYVO/integrations-API-content_3-2.png?format=auto",
  },
};

const Solutions = {
  BrandGuidelines: {
    hero: "https://cdn.lingoapp.com/rXzySBG/solutions-brandGuidelines-hero_3-2.png?format=auto",
    contentContext:
      "https://cdn.lingoapp.com/8ycBzcP/solutions-brandGuidelines-contentContext_3-2.png?format=auto",
    customBranding:
      "https://cdn.lingoapp.com/T6yTU7v/solutions-brandGuidelines-customBranding_3-2.png?format=auto",
    publicSharing:
      "https://cdn.lingoapp.com/KCTdsis/solutions-brandGuidelines-publicSharing_3-2.png?format=auto",
    versionHistory:
      "https://cdn.lingoapp.com/RqTrnl9/solutions-brandGuidelines-versionHistory_3-2.png?format=auto",
  },
  DAM: {
    hero: "https://cdn.lingoapp.com/xbn2Og9/solutions-DAM-hero_3-2.png?format=auto",
    affordable: "https://cdn.lingoapp.com/9grQqaY/solutions-DAM-affordable_3-2.png?format=auto",
    customMetadata:
      "https://cdn.lingoapp.com/9CvuNha/solutions-DAM-customMetadata_3-2.png?format=auto",
    selfServe: "https://cdn.lingoapp.com/wnDSoID/solutions-DAM-selfServe_3-2.png?format=auto",
    visuallyBrowse:
      "https://cdn.lingoapp.com/FkjSVgF/solutions-DAM-visuallyBrowse_3-2.png?format=auto",
  },
  brandHub: {
    hero: "https://cdn.lingoapp.com/JcSJN4y/solutions-brandHub-hero_3-2.png?format=auto",
    allAssets: "https://cdn.lingoapp.com/cRK7LM6/solutions-brandHub-allAssets_3-2.png?format=auto",
    contentContext:
      "https://cdn.lingoapp.com/RKIiGYf/solutions-brandHub-contentContext_3-2.png?format=auto",
    customBranding:
      "https://cdn.lingoapp.com/P0HElbd/solutions-brandHub-customBranding_3-2.png?format=auto",
    selfServe: "https://cdn.lingoapp.com/BIUI81d/solutions-brandHub-selfServe_3-2.png?format=auto",
  },
  brandTeam: {
    hero: "https://cdn.lingoapp.com/BIUI81d/solutions-brandHub-selfServe_3-2.png?format=auto",
    figmaIntegration:
      "https://cdn.lingoapp.com/0IgvA3D/solutions-brandTeam-figmaIntegration_3-2.png?format=auto",
    easyToBuild:
      "https://cdn.lingoapp.com/jRXOYBt/solutions-brandTeam-easyToBuild_3-2.png?format=auto",
    fileConversion:
      "https://cdn.lingoapp.com/tUW4j8J/solutions-brandTeam-fileConversion_3-2.png?format=auto",
    publicSharing:
      "https://cdn.lingoapp.com/ezYfL2l/solutions-brandTeam-publicSharing_3-2.png?format=auto",
  },
  agencies: {
    hero: "https://cdn.lingoapp.com/7OgnKeR/solutions-agencies-hero_3-2.png?format=auto",
    affiliateProgram:
      "https://cdn.lingoapp.com/GUCwhVG/solutions-agencies-affiliateProgram_3-2.png?format=auto",
    allClients:
      "https://cdn.lingoapp.com/WpLYTbW/solutions-agencies-allClients_3-2.png?format=auto",
    fileConversion:
      "https://cdn.lingoapp.com/1bauxXa/solutions-agencies-fileConversion_3-2.png?format=auto",
    upToDate: "https://cdn.lingoapp.com/0a7IxWp/solutions-agencies-upToDate_3-2.png?format=auto",
  },
};

const Enterprise = {
  hero: getImageUrl("/images/marketing/Enterprise/hero_3_2.png"),
  consistency: getImageUrl("/images/marketing/Enterprise/consistency_3_2.png"),
  security: getImageUrl("/images/marketing/Enterprise/security_3_2.png"),
  support: getImageUrl("/images/marketing/Enterprise/support_3_2.png"),
};

const Features = {
  brandPortal: getImageUrl("/images/marketing/Features/brandPortal_16_9.png"),
  customBranding: getImageUrl("/images/marketing/Features/customBranding_16_9.png"),
  customDomains: getImageUrl("/images/marketing/Features/customDomains_16_9.png"),
  customFields: getImageUrl("/images/marketing/Features/customFields_16_9.png"),
  enhancedSearch: getImageUrl("/images/marketing/Features/enhancedSearch_16_9.png"),
  fileConversions: getImageUrl("/images/marketing/Features/fileConversions_16_9.png"),
  guidelines: getImageUrl("/images/marketing/Features/guidelines_16_9.png"),
  insights: getImageUrl("/images/marketing/Features/insights_16_9.png"),
  integrations: getImageUrl("/images/marketing/Features/integrations_16_9.png"),
  tags: getImageUrl("/images/marketing/Features/tags_16_9.png"),
  unlimitedKits: getImageUrl("/images/marketing/Features/unlimitedKits_16_9.png"),
  versionHistory: getImageUrl("/images/marketing/Features/versionHistory_16_9.png"),
  publicSharing: getImageUrl("/images/marketing/Features/publicSharing_16_9.png"),
  downloadRequests: getImageUrl("/images/marketing/Features/downloadRequests_16_9.png"),
};

const CustomerLogos = {
  bumble: getImageUrl("/images/marketing/CustomerLogos/bumble.svg"),
  denison: getImageUrl("/images/marketing/CustomerLogos/denison.svg"),
  duolingo: getImageUrl("/images/marketing/CustomerLogos/duolingo.svg"),
  intuit: getImageUrl("/images/marketing/CustomerLogos/intuit.svg"),
  lime: getImageUrl("/images/marketing/CustomerLogos/lime.svg"),
  matterport: getImageUrl("/images/marketing/CustomerLogos/matterport.svg"),
  reddit: getImageUrl("/images/marketing/CustomerLogos/reddit.svg"),
  snap: getImageUrl("/images/marketing/CustomerLogos/snap.svg"),
  texasam: getImageUrl("/images/marketing/CustomerLogos/texasam.svg"),
  tntsports: getImageUrl("/images/marketing/CustomerLogos/tntsports.svg"),
};

const CTA = {
  default: "https://cdn.lingoapp.com/M4w0Oji/ctaBackground.png?format=auto",
  ctaImport: "https://cdn.lingoapp.com/D6STZ3s/Import.png?format=auto",
};

const Showcase = {
  default: "https://cdn.lingoapp.com/a2Z490X/showcase_3-2.png?format=auto",
};

const Affiliate = {
  hero: getImageUrl("/images/marketing/Affiliate/hero_3_2.png"),
  content: getImageUrl("/images/marketing/Affiliate/content_3_2.png"),
};

const Pricing = {
  hero: getImageUrl("/images/marketing/Pricing/hero_3_2.png"),
  roi: getImageUrl("/images/marketing/Pricing/roi_3_2.png"),
  pricingCalculatorHero:
    "https://cdn.lingoapp.com/F2BG1Ry/pricing-calculator-banner.png?format=auto",
};

const App = {
  transparentColorBackground: getImageUrl("/images/web-access/pattern@2x.png"),
  PortalMigration: {
    introducingMultiplePortals: getImageUrl(
      "/images/modals/portal-migration-modal/IntroducingMultiplePortals.png"
    ),
    newAdminDashboard: getImageUrl("/images/modals/portal-migration-modal/NewAdminDashboard.png"),
    portalSharing: getImageUrl("/images/modals/portal-migration-modal/PortalSharing.png"),
    portalCustomization: getImageUrl(
      "/images/modals/portal-migration-modal/PortalCustomization.png"
    ),
  },
  TemplateKits: {
    styleGuideImage: getImageUrl("/images/modals/TemplateInfoModal-BrandStyleGuide.png"),
    uiLibraryImage: getImageUrl("/images/modals/TemplateInfoModal-UILibrary.png"),
    assetLibraryImage: getImageUrl("/images/modals/TemplateInfoModal-AssetLibrary.png"),
  },
};

const Social = {
  ogShare: getImageUrl("/images/social/og-share.jpg"),
};

const iconSprite = getImageUrl("/icons.svg");

const Images = {
  favicons,
  iconSprite,
  App,
  Social,
  Home,
  Product,
  Integrations,
  Solutions,
  Enterprise,
  Features,
  CustomerLogos,
  CTA,
  Showcase,
  Affiliate,
  Pricing,
};

export default Images;
